import {DomainObject} from 'shared/store';
import {observable, action, computed} from 'mobx';
import {dateFormatter} from 'shared/tools';
import {formatCurrency} from 'shared/core';
import {AttachedDocument} from '../documents';

class Expense extends DomainObject {
  @observable id;
  @observable title;
  @observable amount;
  @observable date;
  @observable category;
  @observable note;
  @observable nmbrLineItemId;
  @observable nmbrPresetId;
  @observable receipts;

  @action merge(other) {
    super.merge(other, {
      receipts: [AttachedDocument]
    });
  }

  @computed get dateView() {
    return dateFormatter(this.date);
  }

  @computed get amountView() {
    return formatCurrency('CAD', this.amount);
  }
}

export default Expense;
